import axios from "./axiosInstance";

const homepageAPI ={ 
    homepage_list: () => axios.get("homepage"),
}

export default homepageAPI;